import React from 'react'
import PropTypes from 'prop-types'
import { theme } from '../../../style'
import Block from '../Block'

const Circle = ({
    radius,
    borderColor,
    style,
    ...rest
}) => (
    <Block
        p="Z"
        justifyContent="center"
        alignItems="center"
        style={{
            width: radius,
            height: radius,
            borderRadius: radius,
            borderColor,
            borderStyle: 'solid',
            borderWidth: borderColor !== 'transparent' ? 1 : 1,
            ...style,
        }}
        {...rest}
    />
)

Circle.propTypes = {
    radius: PropTypes.number,
    borderColor: PropTypes.oneOf(Object.keys(theme)),
    style: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    // Plus all props from Block comp
}

Circle.defaultProps = {
    radius: 50,
    borderColor: 'transparent',
    style: {},
}

export default Circle
